<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-images.vue';

const b = bem('page-key-folder');
export default {
  components: { UploadImages },
  data() {
    return {
      isNewPage: false,
      title: '',
      description: '',
      titleMobile: '',
      descriptionMobile: '',
      files: [],
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
    pageKey: {
      type: String,
      required: true,
    },
    selectedFolder: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createOrEditPageContentAction: 'pageContent/createOrEditPageContent',
    }),
    handleOk(values) {
      const data = {
        id: this.selectedFolder.id || null,
        page: this.pageKey,
        params: {
          name: 'folder',
          title: values.title,
          description: values.description,
          titleMobile: values.titleMobile,
          descriptionMobile: values.descriptionMobile,
          pageKey: this.pageKey,
          imageUrl: this.files[0].file ? this.files : this.files.map((item) => item.url),
          imageUrlMobile: this.files[0].file ? this.files : this.files.map((item) => item.url),
          isShowVideo: false,
          index: this.selectedFolder.id ? this.selectedFolder.index : this.index,
          productId: 0,
          optionId: 0,
        },
      };
      this.createOrEditPageContentAction(data);
      this.hideModal();
    },
  },
  mounted() {
    if (this.selectedFolder && this.selectedFolder.id) {
      this.title = this.selectedFolder.title;
      this.description = this.selectedFolder.description;
      this.titleMobile = this.selectedFolder.titleMobile;
      this.descriptionMobile = this.selectedFolder.descriptionMobile;
      this.files = [this.selectedFolder.imageUrl];
    }
  },
  watch: {
    selectedFolder: {
      handler(newV) {
        this.title = newV.title || '';
        this.description = newV.description || '';
        this.titleMobile = newV.titleMobile || '';
        this.descriptionMobile = newV.descriptionMobile || '';
        this.files = newV.imageUrl ? [newV.imageUrl] : [];
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div :class="b('popup')" v-if="show">
    <div :class="b('')">
      <FormKit
          type="form"
          :submit-label="this.selectedFolder && this.selectedFolder.id
            ? 'Save folder'
            : 'New folder'"
          @submit="handleOk"
      >
        <FormKit
            type="text"
            name="title"
            label="Title"
            placeholder="Please type title"
            v-model="title"
            validation="required"
        />
        <FormKit
            type="text"
            name="titleMobile"
            label="Title mobile"
            placeholder="Please type mobile title"
            v-model="titleMobile"
            validation="required"
        />
        <FormKit
            type="textarea"
            name="description"
            label="Description"
            placeholder="Please type description"
            v-model="description"
            validation="required"
        />
        <FormKit
            type="textarea"
            name="descriptionMobile"
            label="Description mobile"
            placeholder="Please type mobile description"
            v-model="descriptionMobile"
            validation="required"
        />
      </FormKit>
      <div :class="b('right-side')">
        <UploadImages
            :is-multiple="false"
            v-model:files="files"
            :initial-images="files"
        />
      </div>
      <button :class="b('cancel-btn')" @click="hideModal">Cancel</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";

.page-key-folder {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  position: relative;

  &__popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;
  }

  &__cancel-btn {
    position: absolute;
    bottom: 35px;
    right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 10px;
    border: none;
    cursor: pointer;
  }
}
</style>
